import type { CaseReviewBundle } from '@/types/visit'
import IntakePanel from './IntakePanel'
import MedicalHistoryPanel from './MedicalHistoryPanel'
import PhotoViewer from './PhotoViewer'
import PhotoComparison from './PhotoComparison'

export default function PreVisitContent({ bundle }: { bundle: CaseReviewBundle }) {
  return (
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
      <div className="space-y-6 lg:max-h-[calc(100vh-200px)] lg:overflow-y-auto">
        <IntakePanel intake={bundle.intake} />
        <MedicalHistoryPanel medicalHistory={bundle.medical_history} />
      </div>

      <div className="space-y-6">
        <PhotoViewer photos={bundle.photos} />
        {bundle.reference_photos.length > 0 && (
          <PhotoComparison
            currentPhotos={bundle.photos}
            referencePhotos={bundle.reference_photos}
          />
        )}
      </div>
    </div>
  )
}
